module.exports = __webpack_public_path__ + "static/img/arrow.c5fc4aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/time-attendance/arrow.png
// module id = UKVB
// module chunks = 0